<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  beforeCreate() {
    this.$store.dispatch('getIp')
  },
  methods: {

  },
}
</script>

<!-- 安装依赖less、less-loader，并在style上添加属性 lang="less" 就可以支持less语法 -->
<!-- vue/cli3中默认开启了autoprefixer，可以在package.json中的browserslist上配置目标浏览器 -->
<style lang="less">
  @import "./styles/init";
  #app {
    min-height: 100vh;
    background-color: #fff;
  }
</style>
